import React from 'react';
import PropTypes from 'prop-types';
import RouteTabComponent from '../RouteTabComponent';
import TicketTimeComponent from './TicketTimeComponent';
import componentBase from '../../../../../../../../src/lib/component-base';

@componentBase('FlightTicketComponent')
export default class FlightTicketComponent extends React.Component {
  static propTypes = {
    additionalFlightInfo: PropTypes.object,
    arrivalAirport: PropTypes.object,
    codeshares: PropTypes.array,
    departureAirport: PropTypes.object,
    divertedAirport: PropTypes.object,
    operatedBy: PropTypes.string,
    status: PropTypes.object,
    ticketHeader: PropTypes.object,
  };

  static defaultProps = {
    additionalFlightInfo: { equipment: null, flightDuration: null },
    arrivalAirport: null,
    codeshares: null,
    departureAirport: null,
    divertedAirport: null,
    operatedBy: null,
    status: null,
    ticketHeader: null,
  };

  constructor(props, context) {
    super(props, context);

    this.currentFlightState = null;

    this.muiDefaultProps = {
      divStyle: {
        margin: '5px 0 0 0',
        width: '100%',
      },
      flightTicketHeaderStyle: {
        padding: '0',
      },
      flightTicketHeaderCarrierStyle: {
        padding: '10px 2px 10px 20px',
        borderBottom: '1px solid',
      },
      carrierBoxStyle: {
        display: 'inline-block',
        minWidth: '175px',
        width: '40%',
      },
      flightNumberTextStyle: {
        fontSize: '18pt',
        margin: '0 0 10px',
        maxWidth: '150px',
      },
      carrierTextStyle: {
        fontSize: '12pt',
        margin: '0',
      },
      statusBoxStyle: {
        padding: '0',
      },
      statusTextStyle: {
        fontSize: '17pt',
        marginLeft: '20px',
        lineHeight: '19pt',
        height: '28px',
        bottom: '0',
      },
      statusDescriptionDivStyle: {
        marginLeft: '20px',
        height: '71px',
      },
      statusDescriptionCancelledDivStyle: {
        textAlign: 'center',
        borderBottom: '1px solid',
      },
      statusDescriptionStyle: {
        fontWeight: 700,
        display: 'table-cell',
        verticalAlign: 'middle',
        lineHeight: '22pt',
        height: '71px',
        fontSize: '20pt',
      },
      statusCancelledDescriptionStyle: {
        fontWeight: 700,
        fontSize: '32pt',
        marginBottom: '12px',
      },
      operatedTextStyle: {
        fontSize: '12pt',
        lineHeight: '14pt',
        minHeight: '18px',
        margin: '0',
        padding: '5px 20px',
        color: 'rgba(255,255,255,0.7)',
      },
      craftTypeTitleText: {
        fontSize: '12pt',
        marginTop: '0',
        marginBottom: '0',
      },
      craftTypeDataTypeText: {
        margin: '8px 0',
        fontSize: '10pt',
        lineHeight: '12pt',
        color: 'rgba(255, 255, 255, 0.7)',
        height: '14px',
      },
      flightTimeTitleText: {
        fontSize: '12pt',
        margin: '5px 0 10px',
      },
      bigInfoText: {
        fontSize: '18pt',
        fontWeight: 700,
        margin: '5px 0',
      },
      craftTypeNotAvailable: {
        fontSize: '18pt',
        fontWeight: 700,
        marginTop: '65px',
      },
      additionalInfoBoxStyle: {
        padding: '15px 0 0',
      },
      additionalInfoBoxInner: {
        padding: '0 5px',
        margin: '0',
        borderLeft: '1px solid #ffffff',
      },
      craftBoxStyle: {
        padding: '3px 5px 10px 15px',
        height: '113px',
        borderBottom: '1px solid #ffffff',
      },
      craftTypeTextHeader: {
        margin: '20px 0 10px',
        fontSize: '10pt',
        lineHeight: '12pt',
        color: 'rgba(255, 255, 255, 0.7)',
      },
      flightTimeBoxStyle: {
        padding: '13px 5px 5px 15px',
        height: '63px',
      },
      flightTimeInfo: {
        fontSize: '18pt',
        fontWeight: 700,
        margin: '19px 0',
      },
      flightNumberMobileTextStyle: {
        fontSize: '15pt',
        paddingLeft: '20px',
        lineHeight: '15pt',
        margin: '5px 0',
      },
      statusDescriptionMobileTextStyle: {
        padding: '0',
        paddingLeft: '10px',
        width: '44%',
        display: 'inline-block',
        fontSize: '14pt',
        lineHeight: '14pt',
        fontWeight: 'bolder',
        margin: '5px 0',
      },
      statusMobileTextStyle: {
        padding: '0',
        display: 'inline-block',
        fontSize: '14pt',
        lineHeight: '14pt',
        fontWeight: '100',
        margin: '5px 0',
      },
      operatedTextMobileStyle: {
        fontSize: '12pt',
        lineHeight: '14pt',
        minHeight: '18px',
        margin: '0',
        marginTop: '10px',
        padding: '5px 15px',
        color: 'rgba(255,255,255,0.7)',
        borderTop: '2px solid #ffffff',
      },
      additionalInfoBoxSmallStyle: {
        padding: '10px 0',
      },
      additionalInfoBoxSmallInner: {
        padding: '0 5px',
        margin: '0',
        borderRight: '1px solid #ffffff',
      },
      craftBoxSmallStyle: {
        padding: '13px 5px 10px 15px',
        height: '103px',
      },
      flightTimeBoxSmallInner: {
        padding: '0 5px',
        margin: '0',
      },
      flightTimeBoxSmallStyle: {
        padding: '8px 5px 5px 15px',
        height: '63px',
      },
      flightTimeSmallInfo: {
        fontSize: '18pt',
        fontWeight: '700',
        margin: '67px 0 0',
      },
    };
  }

  componentDidMount() {
    // On page load, report Airline and Airports
    const arrivalAirport = this.props.ticketHeader.arrivalAirport;
    const departureAirport = this.props.ticketHeader.departureAirport;

    this.context.reportEvent('Airport', departureAirport.fs, 'Departing', null, true);
    this.context.reportEvent('Airport', arrivalAirport.fs, 'Arriving', null, true);
    this.context.reportEvent('Airline', this.props.ticketHeader.carrier.fs, null, null, true);

    this._reportFlightState(this.props);
  }

  componentWillReceiveProps(newProps) {
    this._reportFlightState(newProps);
  }

  _reportFlightState(currentProps) {
    if (currentProps.flightState !== this.currentFlightState) {
      this.currentFlightState = currentProps.flightState;
      this.context.reportEvent('FlightState', this.currentFlightState, null, null, true);
    }
  }

  render() {
    let statusDivStyle = this.muiDefaultProps.statusDescriptionDivStyle;
    let statusDescriptionElement = '';
    let mobileStatusDescription = '';
    let statusText = !this.props.status.diverted ? this.props.status.status : this.props.status.statusDescription;

    if (this.props.status.status === 'Cancelled' || this.props.status.status === 'Unknown') {
      statusText = '';
      statusDescriptionElement = (<p style={this.muiDefaultProps.statusCancelledDescriptionStyle}>{this.props.status.status}</p>);
      statusDivStyle = this.muiDefaultProps.statusDescriptionCancelledDivStyle;
      mobileStatusDescription = this.props.status.status;
    } else if (this.props.status.statusDescription || this.props.status.diverted) {
      statusDescriptionElement = (<p style={this.muiDefaultProps.statusDescriptionStyle}>{!this.props.status.diverted ? this.props.status.statusDescription : this.props.status.status}</p>);
      mobileStatusDescription = !this.props.status.diverted ? this.props.status.statusDescription : this.props.status.status;
    }

    let craftTypeElement = '';
    if (this.props.additionalFlightInfo.equipment != null) {
      craftTypeElement = (
        <div>
          <p style={this.muiDefaultProps.craftTypeDataTypeText}>{this.props.additionalFlightInfo.equipment.title}</p>
          <p style={this.muiDefaultProps.craftTypeTextHeader}>{this.props.additionalFlightInfo.equipment.name}</p>
          <p style={this.muiDefaultProps.bigInfoText}>{this.props.additionalFlightInfo.equipment.iata}</p>
        </div>
      );
    } else {
      craftTypeElement = (
        <p style={this.muiDefaultProps.craftTypeNotAvailable}>Craft Not Available</p>
      );
    }

    return (
      <div style={this.muiDefaultProps.divStyle} className={`flight-ticket ${this.props.status.color}`} >
        <div className='row visible-sm visible-md visible-lg'>
          <div style={this.muiDefaultProps.flightTicketHeaderStyle} className='col-sm-8 col-md-8 col-lg-8'>
            <div style={this.muiDefaultProps.flightTicketHeaderCarrierStyle} className={`flight-ticket-header ${this.props.status.color}`}>
              <div style={this.muiDefaultProps.carrierBoxStyle}>
                <p style={this.muiDefaultProps.flightNumberTextStyle}>
                  {this.props.ticketHeader.carrier.fs}{this.props.ticketHeader.flightNumber}
                </p>
                <p style={this.muiDefaultProps.carrierTextStyle}>
                  {this.props.ticketHeader.carrier.name}
                </p>
              </div>
              <RouteTabComponent
                index={-1}
                arrivalFS={this.props.ticketHeader.arrivalAirport.fs}
                arrivalCity={this.props.ticketHeader.arrivalAirport.city}
                departureFS={this.props.ticketHeader.departureAirport.fs}
                departureCity={this.props.ticketHeader.departureAirport.city}
              />
            </div>
          </div>
          <div style={this.muiDefaultProps.statusBoxStyle} className={`flight-status-box ${this.props.status.color} col-sm-4 col-md-4 col-lg-4`}>
            <div className={`flight-status-inner-box ${this.props.status.color}`} style={statusDivStyle}>{statusDescriptionElement}</div>
          </div>
        </div>
        <div className='row row-eq-height hidden-xs visible-sm visible-md visible-lg'>
          <div className='col-sm-8 col-md-8 col-lg-8'>
            <p className={`flight-ticket-operated-by ${this.props.status.color}`} style={this.muiDefaultProps.operatedTextStyle}>{this.props.operatedBy}</p>
          </div>
          <div className={`flight-status-box ${this.props.status.color} col-sm-4 col-md-4 col-lg-4`}>
            <div style={this.muiDefaultProps.statusTextStyle}>{statusText}</div>
          </div>
        </div>
        <div className={`row hidden-sm hidden-md hidden-lg flight-ticket-header ${this.props.status.color}`}>
          <div style={this.muiDefaultProps.flightTicketHeaderStyle} className='col-xs-4'>
            <p style={this.muiDefaultProps.flightNumberMobileTextStyle}>{this.props.ticketHeader.carrier.fs}{this.props.ticketHeader.flightNumber}</p>
          </div>
          <div className={`flight-status-box ${this.props.status.color} col-xs-8`}>
            <p style={this.muiDefaultProps.statusDescriptionMobileTextStyle}>{mobileStatusDescription}</p>
            <p style={this.muiDefaultProps.statusMobileTextStyle}>{statusText}</p>
          </div>
        </div>
        <div className={`row hidden-sm hidden-md hidden-lg flight-ticket-header ${this.props.status.color}`}>
          <div style={this.muiDefaultProps.flightTicketHeaderStyle} className='col-xs-12'>
            <RouteTabComponent
              index={-1}
              arrivalFS={this.props.ticketHeader.arrivalAirport.fs}
              arrivalCity={this.props.ticketHeader.arrivalAirport.city}
              departureFS={this.props.ticketHeader.departureAirport.fs}
              departureCity={this.props.ticketHeader.departureAirport.city}
            />
            <p className={`flight-ticket-operated-by ${this.props.status.color}`} style={this.muiDefaultProps.operatedTextMobileStyle}>{this.props.operatedBy}</p>
          </div>
        </div>
        <div className='row visible-md visible-lg'>
          <TicketTimeComponent
            status={this.props.status.status}
            redirected={this.props.status.redirected}
            arrival={false}
            departureInfo={this.props.departureAirport}
          />
          <TicketTimeComponent
            status={this.props.status.status}
            redirected={this.props.status.redirected}
            arrival
            arrivalInfo={this.props.divertedAirport ? this.props.divertedAirport : this.props.arrivalAirport}
          />
          <div style={this.muiDefaultProps.additionalInfoBoxStyle} className='col-md-4 col-lg-4'>
            <div style={this.muiDefaultProps.additionalInfoBoxInner}>
              <div style={this.muiDefaultProps.craftBoxStyle}>
                <p style={this.muiDefaultProps.craftTypeTitleText}>Craft Type</p>
                {craftTypeElement}
              </div>
              <div style={this.muiDefaultProps.flightTimeBoxStyle}>
                <p style={this.muiDefaultProps.flightTimeTitleText}>Flight Time</p>
                <p style={this.muiDefaultProps.flightTimeInfo}>{this.props.additionalFlightInfo.flightDuration && this.props.additionalFlightInfo.flightDuration !== 'n/a' ? this.props.additionalFlightInfo.flightDuration : '--'}</p>
              </div>
            </div>
          </div>
        </div>
        <div className='row visible-sm'>
          <TicketTimeComponent
            status={this.props.status.status}
            redirected={this.props.status.redirected}
            arrival={false}
            departureInfo={this.props.departureAirport}
          />
          <TicketTimeComponent
            status={this.props.status.status}
            redirected={this.props.status.redirected}
            arrival
            arrivalInfo={this.props.divertedAirport ? this.props.divertedAirport : this.props.arrivalAirport}
          />
        </div>
        <div className='row visible-sm'>
          <div style={this.muiDefaultProps.additionalInfoBoxSmallStyle} className='col-sm-6'>
            <div style={this.muiDefaultProps.additionalInfoBoxSmallInner}>
              <div style={this.muiDefaultProps.craftBoxSmallStyle}>
                <p style={this.muiDefaultProps.craftTypeTitleText}>Craft Type</p>
                {craftTypeElement}
              </div>
            </div>
          </div>
          <div style={this.muiDefaultProps.additionalInfoBoxSmallStyle} className='col-sm-6'>
            <div style={this.muiDefaultProps.flightTimeBoxSmallInner}>
              <div style={this.muiDefaultProps.flightTimeBoxSmallStyle}>
                <p style={this.muiDefaultProps.flightTimeTitleText}>Flight Time</p>
                <p style={this.muiDefaultProps.flightTimeSmallInfo}>{this.props.additionalFlightInfo.flightDuration && this.props.additionalFlightInfo.flightDuration !== 'n/a' ? this.props.additionalFlightInfo.flightDuration : '--'}</p>
              </div>
            </div>
          </div>
        </div>
        <div className='row hidden-sm hidden-md hidden-lg'>
          <TicketTimeComponent
            status={this.props.status.status}
            redirected={this.props.status.redirected}
            arrival={false}
            departureInfo={this.props.departureAirport}
            additionalFlightInfo={this.props.additionalFlightInfo}
          />
          <TicketTimeComponent
            status={this.props.status.status}
            redirected={this.props.status.redirected}
            arrival
            arrivalInfo={this.props.divertedAirport ? this.props.divertedAirport : this.props.arrivalAirport}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/SingleFlight/children/FlightTracker/children/FlightInformation/children/FlightTicket/FlightTicketComponent.js